// Simple image cache manager
class ImageCache {
  constructor() {
    this.cache = new Map();
    this.maxSize = 50; // Keep last 50 images in cache
  }

  preloadImage(url) {
    if (!url || this.cache.has(url)) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        this.cache.set(url, true);
        
        // Remove oldest entries if cache is too large
        if (this.cache.size > this.maxSize) {
          const firstKey = this.cache.keys().next().value;
          this.cache.delete(firstKey);
        }
        
        resolve();
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  preloadImages(urls) {
    return Promise.all(urls.map(url => this.preloadImage(url)));
  }

  isLoaded(url) {
    return this.cache.has(url);
  }

  clear() {
    this.cache.clear();
  }
}

export default new ImageCache();